import { IPurchaseOptions } from "@/types";
import { BillingCycle } from "@next-platform/client-common-core/user/types";
import { InputProps } from "@nextui-org/react";

export interface OrderSummaryItemsProps {
  items: { name: string }[];
  billingPeriod: BillingCycle;
  updateCoupon?: (value: string) => void;
  setIsChangePlanLoading?: (value: boolean) => void;
  purchaseOptions: IPurchaseOptions | null;
}

export interface CreditCardSummaryProps {
  last_4: string;
  type: string;
  exp: string;
  onChangeButtonClick: (value: boolean) => void;
}

export interface PersonalInfoSummaryProps {
  country: string;
  state: string;
  postal_code: string;
  first_name: string;
  last_name: string;
  onChangeButtonClick: () => void;
}

export interface InputPostalCodeProps {
  postalCode: string;
  countryCode: string;
  updatePersonalInfo: (field: string, value: string) => void;
  variant: InputProps["variant"];
}

export type PriceData = {
  discounts: {
    code: string;
    valid: boolean;
    error: string;
    total: string;
  }[];
  line_items: {
    name: string;
    id: string;
    total: string;
  }[];
  subtotal: string;
  total: string;
  tax?: {
    pct?: string;
    total?: string;
  };
  currency: string;
  on_file: {
    order_id: string;
    first_name: string;
    last_name: string;
    postal_code: string;
    country: string;
    state: string;
    credit_card: {
      last_4: string;
      exp: string;
      type: string;
    };
  };
};

export interface PurchaseCompleteEvent {
  user_id: string | null;
  plan_id: string;
  transaction_id: string | undefined;
  total_amount: string | undefined;
  currency: string | undefined;
  timestamp: string;
}
export interface PurchaseEvent {
  transaction_id: string | undefined;
  currency: string | undefined;
  timestamp: string;
  value: number;
  items: {
    item_id: string;
    item_name: string;
    price: number;
    quantity: number;
  }[];
}

export enum CheckoutExitPoints {
  USER_DETAILS = "user_details",
  PAYMENT_INFO = "payment_info",
  CHECKBOX_MARK = "checkbox_mark",
}
